import { services } from "../../app/services";
import { ProductType } from "../../helpers/enums/productType";

export const generateEmptyTile = (productType: ProductType) => ({
  available: true,
  productType,
  url: services[productType].url,
  loading: false,
  actionButtonText: "Global.MoreInfo",
});
